import mapKnownValues from "../../utils/mapKnownValues";
import MarketingMaterialDemo from "./marketingMaterial/marketingMaterialDemo";
import MarketingMaterialManifestCake from "./marketingMaterial/marketingMaterialManifestCake";
import MarketingMaterialStandeeBenefitsFair from "./marketingMaterial/marketingMaterialStandeeBenefitsFair";
import MarketingMaterialPostersAndBrochures from "./marketingMaterial/marketingMaterialPostersAndBrochures";
import MarketingMaterialPostcard from "./marketingMaterial/marketingMaterialPostCard";
import { MailingDetailsWithItemQuantity } from "./mailingDetailsWithItemQuantity";
import MarketingMaterialPosters from "./marketingMaterial/marketingMaterialPosters";
import MarketingMaterialBrochures from "./marketingMaterial/marketingMaterialBrochures";

export type ResourceOrderTypeNames =
  | "postcard"
  | "poster-brochure"
  | "poster"
  | "brochure"
  | "standees-and-video"
  | "manifest-demo"
  | "manifest-cake";

export type ResourceOrderTypes =
  | MarketingMaterialDemo
  | MarketingMaterialManifestCake
  | MarketingMaterialStandeeBenefitsFair
  | MarketingMaterialPostersAndBrochures
  | MarketingMaterialPostcard
  | MarketingMaterialPosters
  | MarketingMaterialBrochures;

export type ResourceOrderAPIResponse = {
  orderDate: string;
  resourceOrderType: ResourceOrderTypeNames;
  addresses: MailingDetailsWithItemQuantity[];
  firstName: null | string;
  lastName: null | string;
  mailDate: null | string;
  resourceNames: string[];
  resourceOrderId: number;
  tenantId: number;
  workEmail: null | string;
};

export default class ResourceOrder {
  orderDate = new Date();
  resourceOrderType: ResourceOrderTypeNames = "postcard";
  addresses: MailingDetailsWithItemQuantity[] = [];
  firstName: null | string = null;
  lastName: null | string = null;
  mailDate: null | string = null;
  resourceNames: string[] = [];
  resourceOrderId = -1;
  tenantId = -1;
  workEmail: null | string = null;

  constructor(params: Partial<ResourceOrder> = {}) {
    mapKnownValues(this, params);
  }

  static fromAPI(response: ResourceOrderAPIResponse) {
    return new ResourceOrder({
      ...response,
      orderDate: new Date(response.orderDate),
    });
  }
}
